import React from 'react';
import styled from 'styled-components';
import { Link, useNavigate } from 'react-router-dom';

import MasterPage from '../libs/MasterPage';
import { useBookmarks, useTokens } from '../libs/SamState';
import { formatImageUrl } from '../libs/ImageFormatter';
import { Divider } from '../libs/Contact';

import app from '../appData';

const StyledContainer = styled.div`
    max-width: 500px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    p {
        width: 100%;
        font-size: 14px;
        line-height: 22px;
        color: black;
        margin-top: 0;
        margin-bottom: 0;
    }
    h2 {
        font-size: 18px;
    }
    h3 {
        font-size: 16px;
        line-height: 22px;
        margin-bottom: 0;
        margin-top: 0;
        font-weight: bold;
    }
`
const LoginLink = styled.span`
    text-decoration: underline;
    cursor: pointer;
`
const Retailers: React.FC = () => {
    const { setBookmark } = useBookmarks();
    const { getToken } = useTokens();
    const navigate = useNavigate();

    const handleLogin = () => {
        setBookmark();
        navigate("/login");
        return false;
    }

    return (
        <MasterPage>
            <h1>Become a Retailer of Jacob's Musical Chimes</h1>
            <StyledContainer>
                <h2>If you own a retail store, it is easy to order from Jacob's Musical Chimes!</h2>

                <Divider src={formatImageUrl(app.twigDividerImage)} />

                <h3>Find Us on Faire... Just check out these perks:</h3>
                <p>60-day payment terms for eligible retailers</p>
                <p>Instant, easy ordering from hundreds of makers with a single Faire account</p>
                <p>Free returns on your first order, handled by Faire</p>
                <p>If you are not yet a Faire buyer, you may qualify for various perks &mdash; check their web site for the latest</p>
                <p style={{ textDecoration: "underline" }}><a href=" https://faire.com/direct/jacobsmusicalchimes"> Visit our Faire store to find out!</a></p>

                <Divider src={formatImageUrl(app.twigDividerImage)} />

                <h3>Order on indieme.com:</h3>
                <p><a style={{ textDecoration: "underline" }} href="https://www.indieme.com">Click here and search for store #24762</a></p>

                <Divider src={formatImageUrl(app.twigDividerImage)} />

                <h3>Call, fax or email your order</h3>
                <p>Phone (800) 627-5840</p>
                <p>Fax (510) 529-4833</p>
                <p>Email <a style={{ textDecoration: "underline" }} href="mailto:orders@jacobschimes.com">orders@jacobschimes.com</a></p>

                <Divider src={formatImageUrl(app.twigDividerImage)} />

                <h3>Order online</h3>
                {getToken() ? (
                    <span>As you browse products, click the &quot;Add to cart&quot; button</span>
                ) : (
                    <LoginLink onClick={handleLogin}>Click here to sign in or register and create a shopping cart</LoginLink>
                )}

                <div>
                    <Divider src={formatImageUrl(app.twigDividerImage)} />
                    <h3>Find a rep</h3>
                </div>
                <p><Link style={{ textDecoration: "underline" }} to="/reps">Click here to view our current rep list.</Link></p>
                <Divider src={formatImageUrl(app.twigDividerImage)} />

                <h3>View our catalog</h3>
                <p><Link style={{ textDecoration: "underline" }} to="/catalog">Click here to view a PDF Jacob's Musical Chimes catalog</Link></p>
            </StyledContainer>
        </MasterPage>
    );
}

export default Retailers;


